import { useMutation, useQueryClient } from '@tanstack/react-query';
import { createNote, updateNote, deleteNote } from '../api';
import type { Note, NoteCreate, NoteUpdate } from '../types/note';

export function useCreateNote() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (note: NoteCreate) => createNote(note),
    onSuccess: () => {
      // Invalidate all notes queries to refetch the list
      queryClient.invalidateQueries({ queryKey: ['notes'] });
    },
  });
}

export function useUpdateNote() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: ({ id, note }: { id: number; note: NoteUpdate }) => updateNote(id, note),
    onSuccess: (updatedNote) => {
      // Invalidate specific note query
      queryClient.invalidateQueries({ queryKey: ['note', updatedNote.id] });
      // Invalidate all notes queries to refetch lists
      queryClient.invalidateQueries({ queryKey: ['notes'] });
    },
  });
}

export function useDeleteNote() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (id: number) => deleteNote(id),
    onSuccess: (_, deletedId) => {
      // Invalidate specific note query
      queryClient.invalidateQueries({ queryKey: ['note', deletedId] });
      // Invalidate all notes queries to refetch lists
      queryClient.invalidateQueries({ queryKey: ['notes'] });
    },
  });
}
